import { Stack, Tooltip, Typography } from '@mui/material';
import { type InventoryResource } from '@repo/api-gw-sdk';
import type { Row, Table } from '@tanstack/react-table';
import classNames from 'classnames';

import { hasSecurityIssue } from '../../security/securityUtils';
import { SkullIcon } from '../../security/skullIcon';

interface ResourceNameCellProps {
  row: Row<InventoryResource>;
  table: Table<InventoryResource>;
}

export const ResourceNameCell = ({ row, table }: ResourceNameCellProps) => {
  const toggleResourcePanel = () => {
    if (row.getIsSelected()) {
      table.resetRowSelection(true);
    } else {
      table.setRowSelection({
        [row.id]: true,
      });
    }
  };

  return <BasicResourceNameCell row={row} onClick={toggleResourcePanel} />;
};

export const BasicResourceNameCell = ({
  row,
  onClick,
}: {
  row: Row<InventoryResource>;
  onClick?: () => void;
}) => {
  if (!row.original.resourceName) {
    return null;
  }

  if (hasSecurityIssue(row.original)) {
    return (
      <Stack alignItems='center' direction='row' gap='8px'>
        <Tooltip title='Ransomware indicators were found in the latest snapshot.'>
          <Stack>
            <SkullIcon />
          </Stack>
        </Tooltip>
        <Typography
          data-testid='resource-name-cell'
          className={classNames(
            {
              'underline hover:cursor-pointer [&:hover]:!text-[var(--mui-palette-error-light)]':
                onClick,
            },
            '!text-[var(--mui-palette-error-main)]'
          )}
          onClick={onClick}
        >
          {row.original.resourceName}
        </Typography>
      </Stack>
    );
  }

  return (
    <Typography
      data-testid='resource-name-cell'
      className={
        onClick
          ? 'underline hover:cursor-pointer hover:text-[var(--mui-palette-text-gray1)]'
          : ''
      }
      onClick={onClick}
    >
      {row.original.resourceName}
    </Typography>
  );
};
